import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBgaa16-j9s5R8MC-8EC6XIPh604LHdeX0",
  authDomain: "evonikauth.firebaseapp.com",
  projectId: "evonikauth",
  storageBucket: "evonikauth.firebasestorage.app",
  messagingSenderId: "1032484664190",
  appId: "1:1032484664190:web:44ad9c07312036f950792f",
  measurementId: "G-D0MTVS11N4"
};

export const firebaseApp = initializeApp(firebaseConfig);
